import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-logo">
            <img src="/assets/images/logo.png" alt="Blue Cactus" />
          </div>

          <div className="footer-links">
            <Link to="/" className="footer-link">Home</Link>
            <span className="separator">|</span>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <span className="separator">|</span>
            <Link to="/terms-conditions" className="footer-link">Terms &amp; Conditions</Link>
          </div>

          <p className="footer-copyright">© {currentYear} Blue Cactus. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
